import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import {
    setCaptionInProgress,
    setLiveCaptionViewOn,
    setLocalUserLiveCaptionStart,
    setLocalUserLiveCaptionStop,
} from "../../reducers/liveCaption-reducer";
import useLanguageChange from "../../hooks/useLanguageChange";
import { LogFirebase } from "../../services/firestore";
import { PublicVariables } from "../../constants/PublicVariables";
import { useFlags } from "launchdarkly-react-client-sdk";
import { ENABLED, ROOM_TYPE } from "../../constants/Constants";

export const isLiveCaptionFeatureAvailable = (ldFlag) => {
    return (
        PublicVariables.featureFlag?.SHOWMEROOMTYPE === ROOM_TYPE.GROUP &&
        ldFlag?.liveCaption &&
        PublicVariables.featureFlag?.SHOMEAICALLSUMMARY === ENABLED
    );
};

const LiveCaptionsButton = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const ldFlag = useFlags();
    const { isRemoteParticipantJoined } = useSelector((state) => state.commonReducer);
    const { captionInProgress, liveCaptionViewOn } = useSelector((state) => state.liveCaption);

    const toggleLiveCaptionButton = () => {
        dispatch(setCaptionInProgress(true));
        setTimeout(() => {
            if (liveCaptionViewOn) {
                LogFirebase("LiveCaption", "Local user click stopped live caption button", "true");
                dispatch(setLocalUserLiveCaptionStop(true));
            } else {
                LogFirebase("LiveCaption", "Local user click started live caption button", "true");
                dispatch(setLocalUserLiveCaptionStart(true));
            }
            dispatch(setLiveCaptionViewOn(!liveCaptionViewOn));
            dispatch(setCaptionInProgress(false));
        }, 1000);
    };

    const isLiveCaptionButtonDisabled = () => {
        if (isRemoteParticipantJoined && !captionInProgress) return false;
        return true;
    };

    return (
        <>
            {isLiveCaptionFeatureAvailable(ldFlag) && (
                <div className='action-button'>
                    <div className='action-button-in'>
                        <button
                            className={clsx("call-action-btn", liveCaptionViewOn && !captionInProgress && "active")}
                            id='live-caption-btn'
                            disabled={isLiveCaptionButtonDisabled()}
                            onClick={toggleLiveCaptionButton}
                        >
                            <span className='action-button-icon'>
                                <span className='for-icon icon-live-caption'></span>
                            </span>
                            <span className='for-text'>{localisedValues?.live_captions}</span>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default LiveCaptionsButton;
